import { VendorModule } from "@/store/modules/vendor.module";
import { toaster } from "@/utilities/toaster";
import { Machine } from "xstate";
const vendorMachine = Machine({
    id: "vendor",
    context: {
        vendorId: "",
    },
    initial: "idle",
    states: {
        idle: {
            always: [{ target: "gettingVendorsDetails" }],
        },
        gettingVendorsDetails: {
            invoke: {
                id: "gettingVendorsDetails",
                src: (context, event) => VendorModule.GetVendorListings(),
                onDone: { target: "loadedVendor" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedVendor: {
            on: {
                ADDING_VENDOR: { target: "addingVendor" },
                EDIT_VENDOR: { target: "editingVendor" },
                DELETE_VENDOR: { target: "deleteVendor" },
            },
        },
        addingVendor: {
            tags: "showAddVendorUI",
            on: {
                SAVE_VENDOR: { target: "savingVendor" },
                CANCEL_VENDOR: { target: "loadedVendor" },
            },
        },
        savingVendor: {
            tags: "showAddVendorUI",
            invoke: {
                id: "savingVendor",
                src: (ctx, evt) => VendorModule.CreateVendor(evt.newVendor),
                onDone: { target: "gettingVendorsDetails", actions: ["showSuccessMessage"] },
                onError: { target: "serviceUnavailable" },
            },
        },
        editingVendor: {
            tags: "showEditVendorUI",
            on: {
                UPDATE_VENDOR: { target: "updateVendor" },
                CANCEL_VENDOR: { target: "loadedVendor" },
            },
        },
        updateVendor: {
            tags: "showEditVendorUI",
            invoke: {
                id: "updateVendor",
                src: (ctx, evt) => VendorModule.UpdateVender(evt.updateVendor),
                onDone: { target: "gettingVendorsDetails", actions: ["showSuccessMessage"] },
                onError: { target: "serviceUnavailable" },
            },
        },
        deleteVendor: {
            tags: "showVendorDelete",
            on: {
                DELETING_VENDOR: { target: "deletingVendor" },
                CANCEL_VENDOR: { target: "loadedVendor" },
            },
        },
        deletingVendor: {
            tags: "showVendorDelete",
            invoke: {
                id: "deletingVendor",
                src: (context, event) => VendorModule.DeleteVendor(event.vendorId),
                onDone: { target: "gettingVendorsDetails", actions: "showSuccessMessage" },
                onError: { target: "serviceUnavailable" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
    },
    guards: {},
    activities: {},
    services: {},
});
export default vendorMachine;
